import React from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { AuthContext } from "../../auth/authContext";
import {
  reporteCobranzaRangoFecha,
  reporteCobranzaSerie,
  reporteResumenSerie,
  reporteVentasPrevisionPorFechaAPI,
} from "../../API/ApiReportes";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LoadingComponent } from "../../Components/LoadingComponent/LoadingComponent";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";
import { SinPermisoComponent } from "../../Components/SinPermisoComponent/SinPermisoComponent";
import MultiselectSeriesComponent from "../../Components/MultiselectSeriesComponent/MultiselectSeriesComponent";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import imageVitanova from "../../Images/LogotipoNegro.png";

import imagenVitaNova from "../../Images/LogotipoNegro.png";
import { ButtonDownloadToXlsComponent } from "../../Components/ButtonDownloadToXlsComponent/ButtonDownloadToXlsComponent";

import { useParams } from "react-router-dom";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";

const guidVista = "ef433e95-e3b0-4caa-a533-3b599add112e";

const ListToPrintComponent = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  const [totalSalarios, setTotalSalarios] = React.useState(0.0);

  return (
    <div className="print-source " ref={ref}>
      <img
        alt="Vitanova Logo"
        className="mt-3"
        src={imageVitanova}
        width="150"
      />
      <br />

      <h3 className="mt-3">Reporte total ventas previsión por fecha</h3>
      <h6 className="mb-4">
        <small>Reporte general</small>
      </h6>
      <h6 className="mb-4">
        <small>
          de: {props.fechaInicio} a: {props.fechaFin}
        </small>
      </h6>

      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Contrato</strong>
          </div>
          <div className="col">
            <strong>Fecha</strong>
          </div>
          <div className="col">
            <strong>Importe</strong>
          </div>
          <div className="col">
            <strong>Pagado</strong>
          </div>
          <div className="col">
            <strong>Saldo</strong>
          </div>
        </div>
      </div>
      {props.value.map((empleado, index) => (
        <div className="container-fluid" key={index}>
          <div className="row row-cols-5">
            <div className="col">{empleado.contrato}</div>
            <div className="col">
              {CambiarFormatoFechaHelper(empleado.fechaContrato)}
            </div>
            <div className="col">
              {"$ "}{" "}
              {parseFloat(empleado.totalContrato)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
            <div className="col">
              {"% "}{" "}
              {parseFloat(empleado.pagado)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
            <div className="col">
              {"$ "}{" "}
              {parseFloat(empleado.saldoContrato)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
          </div>
        </div>
      ))}
      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Total:</strong>
          </div>
          <div className="col"></div>
          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalImporteTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>
          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalPagadoTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>

          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalSaldoTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>
        </div>
      </div>
      <br />
    </div>
  );
});

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  return (
    <div className="print-source " ref={ref}>
      <img alt="Vitanova Logo" src={imageVitanova} width="150" />
      <br />
      <br />
      <br />
      <h3>Reporte total ventas previsión por fecha</h3>
      <br />
      <strong>
        {" "}
        de: {props.fechaInicio} a: {props.fechaFin}
      </strong>
      <br />
      <br />
      <table className="table">
        <tbody>
          <tr>
            <td>Contrato</td>
            <td>{props.value.contrato}</td>
          </tr>
          <tr>
            <td>Fecha Contrato</td>
            <td>{props.value.fechaContrato}</td>
          </tr>
          <tr>
            <td>Importe</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.totalContrato)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>Pagado</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.pagado)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>Saldo</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.saldoContrato)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <br />
      __________________________________________________________________
      <br />
      Firma
      <br />
      <br />
      <small style={{ fontSize: "10px" }}>Impreso por: {user.username}</small>
    </div>
  );
});

const ComponentToPrintWrapper = (props) => {
  const componentRef = React.useRef();

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="center">
        <a
          target="_self"
          rel="noreferrer"
          href={`/contrato/${props.item.id}/false`}
        >
          {props.item.contrato}
        </a>
      </TableCell>
      <TableCell align="center">
        {CambiarFormatoFechaHelper(props.item.fechaContrato)}
      </TableCell>
      <TableCell align="center">
        {"$ "}
        {parseFloat(props.item.totalContrato)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>
      <TableCell align="center">
        {"$ "}{" "}
        {parseFloat(props.item.pagado)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>
      <TableCell align="center">
        {"$ "}{" "}
        {parseFloat(props.item.saldoContrato)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>
      <TableCell align="center">
        {" "}
        <ReactToPrint
          trigger={() => (
            <button type="primary" className="btn btn-sm btn-success">
              Imprimir Recibo
            </button>
          )}
          content={() => componentRef.current}
        />
        <ComponentToPrint
          ref={componentRef}
          value={props.item}
          fechaInicio={props.fechaInicio}
          fechaFin={props.fechaFin}
          granTotalImporteTotal={props.granTotalImporteTotal}
          granTotalPagadoTotal={props.granTotalPagadoTotal}
          granTotalSaldoTotal={props.granTotalSaldoTotal}
        />
      </TableCell>
    </TableRow>
  );
};

export const ReporteTotalVentasPrevisionPorFechaComponent = () => {
  const componentRefListado = React.useRef();

  let { fechainicio, fechafin, ejecutar } = useParams();

  const todayInicio = new Date();
  const todayFin = new Date();
  const numberOfDaysToAdd = 15;
  const dateInicio = todayInicio.setDate(
    todayInicio.getDate() - numberOfDaysToAdd
  );
  const dateFin = todayFin.setDate(todayFin.getDate());

  const defaultValueInicio = fechainicio
    ? fechainicio
    : new Date(dateInicio).toISOString().split("T")[0]; // yyyy-mm-dd

  const defaultValueFin = fechafin
    ? fechafin
    : new Date(dateFin).toISOString().split("T")[0]; // yyyy-mm-dd

  const { user, dispatch } = React.useContext(AuthContext);
  const [reporteSerie, setReporteSerie] = React.useState("");
  const [reporteFechaInicial, setReporteFechaInicial] =
    React.useState(defaultValueInicio);
  const [reporteFechaFin, setReporteFechaFin] = React.useState(defaultValueFin);
  const [finalData, setFinalData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [checkPersmissions, setCheckPermissions] = React.useState([]);
  const [permisoParaVisualizar, setPermisoParaVisualizar] =
    React.useState(false);
  const [permisoReporte, setPermisoReporte] = React.useState(false);
  const [seriesSeleccionadas, setSeriesSeleccionadas] = React.useState([]);
  const [granTotalComisionMostrar, setGranTotalComisionMostrar] =
    React.useState(0.0);

  const [granTotalTotalMostrar, setGranTotalTotalMostrar] = React.useState(0.0);

  const [listoParaMandar, setListoParaMandar] = React.useState(false);

  const [granTotalImporteTotal, setGranTotalImporteTotal] = React.useState(0.0);
  const [granTotalPagadoTotal, setGranTotalPagadoTotal] = React.useState(0.0);
  const [granTotalSaldoTotal, setGranTotalSaldoTotal] = React.useState(0.0);

  React.useEffect(() => {
    let listo = false;

    let granTotalImporte = 0.0;
    let granTotalPagado = 0.0;
    let granTotalSaldo = 0.0;

    for (const registro of finalData) {
      granTotalImporte = granTotalImporte + parseFloat(registro.totalContrato);
      granTotalPagado = granTotalPagado + parseFloat(registro.pagado);
      granTotalSaldo = granTotalSaldo + parseFloat(registro.saldoContrato);
    }

    setGranTotalImporteTotal(granTotalImporte);
    setGranTotalPagadoTotal(granTotalPagado);
    setGranTotalSaldoTotal(granTotalSaldo);

    return () => {
      listo = true;
    };
  }, [finalData]);

  React.useEffect(() => {
    let ready = false;

    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == "8f157d70-8d87-4d17-8341-afed9c53b833" &&
              permiso.allowed == 1
            ) {
              setPermisoParaVisualizar(true);
            }
            if (
              permiso.guidFuncion == "41cd64b2-0ee7-4afe-8f5b-c4de4d624ecc" &&
              permiso.allowed == 1
            ) {
              setPermisoReporte(true);
            }
          }
        }
      }
    );

    let listo = false;

    let granTotalComision = 0.0;
    let granTotaltotal = 0.0;

    setGranTotalTotalMostrar(granTotaltotal);
    setGranTotalComisionMostrar(granTotalComision);

    if (ejecutar) {
      setLoading(true);
      reporteVentasPrevisionPorFechaAPI(user, {
        fechaInicio: reporteFechaInicial,
        fechaFin: reporteFechaFin,
      }).then((resultado) => {
        if (resultado.status == 200) {
          setFinalData(resultado.data);
          setLoading(false);
        }
        setLoading(false);
      });
    }
    return () => {
      listo = true;
    };
  }, []);

  return (
    <>
      {permisoParaVisualizar == true && permisoReporte == true ? (
        <>
          <div className="container-fluid mb-2 d-none d-print-block">
            <div className="row">
              <div className="col-12">
                <img src={imagenVitaNova} alt="Logo Vita Nova" height={30} />
              </div>
            </div>
          </div>
          <div className="container-fluid mb-3 mt-2">
            <div className="row row-cols-md-3 d-flex align-items-center">
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Inicio"
                  type="date"
                  variant="standard"
                  value={reporteFechaInicial}
                  onChange={(e) => {
                    setReporteFechaInicial(e.target.value);
                  }}
                />
              </div>
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Fin"
                  type="date"
                  variant="standard"
                  value={reporteFechaFin}
                  onChange={(e) => {
                    setReporteFechaFin(e.target.value);
                  }}
                />
              </div>
              <div className="col d-print-none">
                <button
                  disabled={listoParaMandar}
                  className="btn btn-sm btn-success w-100"
                  onClick={() => {
                    setLoading(true);
                    reporteVentasPrevisionPorFechaAPI(user, {
                      fechaInicio: reporteFechaInicial,
                      fechaFin: reporteFechaFin,
                    }).then((resultado) => {
                      if (resultado.status == 200) {
                        setFinalData(resultado.data);
                      }
                      setLoading(false);
                    });
                  }}
                >
                  {" "}
                  Buscar{" "}
                </button>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-info my-3">
                      Imprimir Reporte General
                    </button>
                  )}
                  content={() => componentRefListado.current}
                />
                <ListToPrintComponent
                  ref={componentRefListado}
                  value={finalData}
                  fechaInicio={reporteFechaInicial}
                  fechaFin={reporteFechaFin}
                  granTotalImporteTotal={granTotalImporteTotal}
                  granTotalPagadoTotal={granTotalPagadoTotal}
                  granTotalSaldoTotal={granTotalSaldoTotal}
                />
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row row-cols-md-1">
              <div className="col" style={{ textAlign: "right" }}>
                <ButtonDownloadToXlsComponent
                  data={finalData}
                  fileName="Reporte total ventas previsión por fecha"
                />
              </div>
            </div>
                      
          </div>

          <div className="container-fluid">
            <div className="row row-cols-1">
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  className="text-center"
                  aria-label="a dense table"
                  align="center"
                >
                  <TableHead align="center">
                    <TableRow align="center">
                      <TableCell align="center">Contrato</TableCell>
                      <TableCell align="center">Fecha Contrato</TableCell>
                      <TableCell align="center">Importe</TableCell>
                      <TableCell align="center">Pagado</TableCell>
                      <TableCell align="center">Saldo</TableCell>
                      <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="center">
                        <strong>Gran Total</strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalImporteTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalPagadoTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>

                      <TableCell align="center">
                        <strong>
                          {"$ "}
                          {granTotalSaldoTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>

                    {finalData.map((row, index) => (
                      <ComponentToPrintWrapper
                        key={index}
                        item={row}
                        fechaInicio={reporteFechaInicial}
                        fechaFin={reporteFechaFin}
                        granTotalImporteTotal={granTotalImporteTotal}
                        granTotalPagadoTotal={granTotalPagadoTotal}
                        granTotalSaldoTotal={granTotalSaldoTotal}
                      />
                    ))}

                    <TableRow>
                      <TableCell align="center">
                        <strong>Gran Total</strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalImporteTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalPagadoTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>

                      <TableCell align="center">
                        <strong>
                          {"$ "}
                          {granTotalSaldoTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          {loading == true ? <LoadingComponent /> : null}
        </>
      ) : (
        <SinPermisoComponent />
      )}
    </>
  );
};
